module.exports = __webpack_public_path__ + "img/home-empresas-1.51ea874.webp";